<script setup>
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
import BottomNav from "../Components/BottomNav.vue";
import Header from "../Components/Header.vue";
import { usePage } from "@inertiajs/inertia-vue3";
import { useToast } from "primevue/usetoast";
import { onMounted, watch } from "vue";

const toast = useToast();
const page = usePage();

const showFlash = (flash) => {
    if (flash?.severity && flash?.value) {
        toast.add({
            severity: flash.severity,
            summary: flash.value,
            life: 5000,
        });
    }
}

onMounted(() => {
    showFlash(page.props.value.flash);
});

watch(() => page.props.value.flash, (newFlash) => {
    showFlash(newFlash);
});
</script>
<template>
    <div class="min-h-screen bg-[#F6F5F1] w-full">
        <Header />
        <slot />
    </div>
    <BottomNav />
    <Toast />
    <Toast position="top-center" group="tc" />
    <ConfirmDialog />
</template>
